export default __webpack_public_path__ + "static/media/AcceptOrderOff.5956603d.svg";